// 🛑 This file is auto-generated by generate-icon-map.js
import Icon0 from "./cause/animal_welfare.svg";
import Icon1 from "./cause/anti_racism.svg";
import Icon2 from "./cause/armed_forces_charities.svg";
import Icon3 from "./cause/autism.svg";
import Icon4 from "./cause/bird_protection.svg";
import Icon5 from "./cause/cancer_charities.svg";
import Icon6 from "./cause/charity_regulation.svg";
import Icon7 from "./cause/childrens_charities.svg";
import Icon8 from "./cause/climate_change.svg";
import Icon9 from "./cause/countryside.svg";
import Icon10 from "./cause/diabetes_charities.svg";
import Icon11 from "./cause/disability.svg";
import Icon12 from "./cause/dog_welfare.svg";
import Icon13 from "./cause/fairtrade.svg";
import Icon14 from "./cause/feminism.svg";
import Icon15 from "./cause/gardens.svg";
import Icon16 from "./cause/homelessness.svg";
import Icon17 from "./cause/human_rights.svg";
import Icon18 from "./cause/legal_rights.svg";
import Icon19 from "./cause/lgbtq_diversity.svg";
import Icon20 from "./cause/lifeboats_and_coastguards.svg";
import Icon21 from "./cause/mental_health.svg";
import Icon22 from "./cause/ms_charities.svg";
import Icon23 from "./cause/national_development.svg";
import Icon24 from "./cause/nature_protection.svg";
import Icon25 from "./cause/ocean_protection.svg";
import Icon26 from "./cause/old_people_supporters.svg";
import Icon27 from "./cause/pet_protection.svg";
import Icon28 from "./cause/planet_protection.svg";
import Icon29 from "./cause/recycling_and_plastic_free.svg";
import Icon30 from "./cause/refugees_and_equality.svg";
import Icon31 from "./cause/renewable_energy.svg";
import Icon32 from "./cause/the_environment.svg";
import Icon33 from "./cause/tv_fundraising.svg";
import Icon34 from "./cause/vegan_lifestyle.svg";
import Icon35 from "./cause/veganism.svg";
import Icon36 from "./cause/world_aid.svg";
import Icon37 from "./cause/world_wildlife.svg";
import Icon38 from "./default.svg";
import Icon39 from "./interest/academia.svg";
import Icon40 from "./interest/accountancy.svg";
import Icon41 from "./interest/action.svg";
import Icon42 from "./interest/action_and_adventure_games.svg";
import Icon43 from "./interest/alcohol.svg";
import Icon44 from "./interest/american_football.svg";
import Icon45 from "./interest/animal_charities.svg";
import Icon46 from "./interest/animation_and_cartoons.svg";
import Icon47 from "./interest/anime.svg";
import Icon48 from "./interest/antiques.svg";
import Icon49 from "./interest/architecture.svg";
import Icon50 from "./interest/art.svg";
import Icon51 from "./interest/art_and_design.svg";
import Icon52 from "./interest/asian_pop_music.svg";
import Icon53 from "./interest/athletics.svg";
import Icon54 from "./interest/award_shows.svg";
import Icon55 from "./interest/baking.svg";
import Icon56 from "./interest/baseball.svg";
import Icon57 from "./interest/basketball.svg";
import Icon58 from "./interest/beauty.svg";
import Icon59 from "./interest/beer_and_cider.svg";
import Icon60 from "./interest/bird_and_wildlife_spotting.svg";
import Icon61 from "./interest/blues_music.svg";
import Icon62 from "./interest/boats.svg";
import Icon63 from "./interest/body_building_and_weightlifting.svg";
import Icon64 from "./interest/bollywood.svg";
import Icon65 from "./interest/books_and_literature.svg";
import Icon66 from "./interest/boxing.svg";
import Icon67 from "./interest/business.svg";
import Icon68 from "./interest/business_advice_and_training.svg";
import Icon69 from "./interest/business_leadership.svg";
import Icon70 from "./interest/business_strategy_and_consultancy.svg";
import Icon71 from "./interest/buying_a_home.svg";
import Icon72 from "./interest/cars.svg";
import Icon73 from "./interest/celebrity_gossip.svg";
import Icon74 from "./interest/chess.svg";
import Icon75 from "./interest/childrens_tv_shows.svg";
import Icon76 from "./interest/classical_music.svg";
import Icon77 from "./interest/climate_and_green_issues.svg";
import Icon78 from "./interest/coffee.svg";
import Icon79 from "./interest/combat_and_fighting_games.svg";
import Icon80 from "./interest/comedy.svg";
import Icon81 from "./interest/comic_books.svg";
import Icon82 from "./interest/computing_and_software.svg";
import Icon83 from "./interest/cooking.svg";
import Icon84 from "./interest/cosmetics.svg";
import Icon85 from "./interest/cosplay.svg";
import Icon86 from "./interest/country_music.svg";
import Icon87 from "./interest/coupons_and_saving_money.svg";
import Icon88 from "./interest/crafts.svg";
import Icon89 from "./interest/cricket.svg";
import Icon90 from "./interest/crime_shows.svg";
import Icon91 from "./interest/cruises.svg";
import Icon92 from "./interest/cycling.svg";
import Icon93 from "./interest/dance_music.svg";
import Icon94 from "./interest/dance_or_ballet.svg";
import Icon95 from "./interest/data.svg";
import Icon96 from "./interest/data_protection.svg";
import Icon97 from "./interest/dating_and_relationships.svg";
import Icon98 from "./interest/design.svg";
import Icon99 from "./interest/diy.svg";
import Icon100 from "./interest/documentaries.svg";
import Icon101 from "./interest/drama.svg";
import Icon102 from "./interest/drawing.svg";
import Icon103 from "./interest/eating_out.svg";
import Icon104 from "./interest/economics.svg";
import Icon105 from "./interest/electric_vehicles.svg";
import Icon106 from "./interest/electronic_music.svg";
import Icon107 from "./interest/electronics.svg";
import Icon108 from "./interest/energy_drinks.svg";
import Icon109 from "./interest/entertainment.svg";
import Icon110 from "./interest/entrepreneurship_and_start_ups.svg";
import Icon111 from "./interest/equestrian_sports.svg";
import Icon112 from "./interest/esports.svg";
import Icon113 from "./interest/ethnic_diversity.svg";
import Icon114 from "./interest/extreme_sports.svg";
import Icon115 from "./interest/family_and_parenting.svg";
import Icon116 from "./interest/fantasy.svg";
import Icon117 from "./interest/fashion.svg";
import Icon118 from "./interest/fashion_affordable.svg";
import Icon119 from "./interest/fashion_luxury.svg";
import Icon120 from "./interest/fashion_premium.svg";
import Icon121 from "./interest/fast_food.svg";
import Icon122 from "./interest/fiction_books.svg";
import Icon123 from "./interest/finance.svg";
import Icon124 from "./interest/financial_technology.svg";
import Icon125 from "./interest/finding_a_job.svg";
import Icon126 from "./interest/fine_art.svg";
import Icon127 from "./interest/fishing.svg";
import Icon128 from "./interest/fitness.svg";
import Icon129 from "./interest/food_and_drink.svg";
import Icon130 from "./interest/food_waste.svg";
import Icon131 from "./interest/football.svg";
import Icon132 from "./interest/furniture.svg";
import Icon133 from "./interest/gambling_and_casinos.svg";
import Icon134 from "./interest/game_shows.svg";
import Icon135 from "./interest/gaming.svg";
import Icon136 from "./interest/gardening.svg";
import Icon137 from "./interest/gender_diversity.svg";
import Icon138 from "./interest/gluten_free.svg";
import Icon139 from "./interest/golf.svg";
import Icon140 from "./interest/gospel_music.svg";
import Icon141 from "./interest/gymnastics.svg";
import Icon142 from "./interest/haircare.svg";
import Icon143 from "./interest/handbags.svg";
import Icon144 from "./interest/health_and_fitness.svg";
import Icon145 from "./interest/health_and_wellbeing.svg";
import Icon146 from "./interest/healthy_eating.svg";
import Icon147 from "./interest/hiking_and_trekking.svg";
import Icon148 from "./interest/hip_hop_music.svg";
import Icon149 from "./interest/historical_drama.svg";
import Icon150 from "./interest/history.svg";
import Icon151 from "./interest/hobbies.svg";
import Icon152 from "./interest/holidays.svg";
import Icon153 from "./interest/horror.svg";
import Icon154 from "./interest/house_and_home.svg";
import Icon155 from "./interest/human_and_civil_rights.svg";
import Icon156 from "./interest/human_resources.svg";
import Icon157 from "./interest/hunting_and_shooting.svg";
import Icon158 from "./interest/insurance.svg";
import Icon159 from "./interest/interior_design.svg";
import Icon160 from "./interest/international_politics.svg";
import Icon161 from "./interest/investment.svg";
import Icon162 from "./interest/jazz_music.svg";
import Icon163 from "./interest/jewellery_and_accessories.svg";
import Icon164 from "./interest/law.svg";
import Icon165 from "./interest/learning_and_education.svg";
import Icon166 from "./interest/legal_drama.svg";
import Icon167 from "./interest/lgbtq.svg";
import Icon168 from "./interest/lifestyle.svg";
import Icon169 from "./interest/lifestyle_tips.svg";
import Icon170 from "./interest/live_music_and_festivals.svg";
import Icon171 from "./interest/local_and_regional_news.svg";
import Icon172 from "./interest/local_and_regional_politics.svg";
import Icon173 from "./interest/magic.svg";
import Icon174 from "./interest/male_grooming.svg";
import Icon175 from "./interest/martial_arts.svg";
import Icon176 from "./interest/maths.svg";
import Icon177 from "./interest/medical_and_health_charities.svg";
import Icon178 from "./interest/medical_drama.svg";
import Icon179 from "./interest/mental_health.svg";
import Icon180 from "./interest/metal_music.svg";
import Icon181 from "./interest/military_and_national_security.svg";
import Icon182 from "./interest/moba_games.svg";
import Icon183 from "./interest/motor_sports.svg";
import Icon184 from "./interest/motorbikes.svg";
import Icon185 from "./interest/motoring.svg";
import Icon186 from "./interest/museums.svg";
import Icon187 from "./interest/music.svg";
import Icon188 from "./interest/music_tv_shows.svg";
import Icon189 from "./interest/musical_drama.svg";
import Icon190 from "./interest/nailcare.svg";
import Icon191 from "./interest/national_and_international_news.svg";
import Icon192 from "./interest/national_politics.svg";
import Icon193 from "./interest/nature_conservation.svg";
import Icon194 from "./interest/netball.svg";
import Icon195 from "./interest/news_and_current_affairs.svg";
import Icon196 from "./interest/news_shows.svg";
import Icon197 from "./interest/no_poverty.svg";
import Icon198 from "./interest/ocean_conservation.svg";
import Icon199 from "./interest/opera.svg";
import Icon200 from "./interest/organic_food.svg";
import Icon201 from "./interest/painting.svg";
import Icon202 from "./interest/performing_arts.svg";
import Icon203 from "./interest/period_drama.svg";
import Icon204 from "./interest/personal_finance.svg";
import Icon205 from "./interest/pets_and_animals.svg";
import Icon206 from "./interest/philanthropy.svg";
import Icon207 from "./interest/philosophy.svg";
import Icon208 from "./interest/phones_and_communication.svg";
import Icon209 from "./interest/photography.svg";
import Icon210 from "./interest/piercing_and_tattoos.svg";
import Icon211 from "./interest/pilates_yoga_and_meditation.svg";
import Icon212 from "./interest/planet_protection.svg";
import Icon213 from "./interest/plastic_free.svg";
import Icon214 from "./interest/playing_music.svg";
import Icon215 from "./interest/poetry.svg";
import Icon216 from "./interest/politics_and_world_affairs.svg";
import Icon217 from "./interest/popular_music.svg";
import Icon218 from "./interest/pr_marketing_and_advertising.svg";
import Icon219 from "./interest/property_and_construction.svg";
import Icon220 from "./interest/public_healthcare.svg";
import Icon221 from "./interest/racing_games.svg";
import Icon222 from "./interest/racket_sports.svg";
import Icon223 from "./interest/radio_shows.svg";
import Icon224 from "./interest/randb_music.svg";
import Icon225 from "./interest/rap_music.svg";
import Icon226 from "./interest/reality_tv_shows.svg";
import Icon227 from "./interest/recycling.svg";
import Icon228 from "./interest/renewable_energy.svg";
import Icon229 from "./interest/rock_music.svg";
import Icon230 from "./interest/romance_drama.svg";
import Icon231 from "./interest/rpg_games.svg";
import Icon232 from "./interest/rugby_league.svg";
import Icon233 from "./interest/rugby_union.svg";
import Icon234 from "./interest/running_marathons_and_triathlons.svg";
import Icon235 from "./interest/science.svg";
import Icon236 from "./interest/science_fiction.svg";
import Icon237 from "./interest/self_improvement.svg";
import Icon238 from "./interest/shoes.svg";
import Icon239 from "./interest/shooter_games.svg";
import Icon240 from "./interest/shopping.svg";
import Icon241 from "./interest/simulation_and_sandbox_games.svg";
import Icon242 from "./interest/singing.svg";
import Icon243 from "./interest/sitcom.svg";
import Icon244 from "./interest/skincare.svg";
import Icon245 from "./interest/sleep_optimisation.svg";
import Icon246 from "./interest/small_business.svg";
import Icon247 from "./interest/smoking_and_vaping.svg";
import Icon248 from "./interest/soap_opera.svg";
import Icon249 from "./interest/socialising.svg";
import Icon250 from "./interest/soft_drinks.svg";
import Icon251 from "./interest/soul_music.svg";
import Icon252 from "./interest/space_and_astronomy.svg";
import Icon253 from "./interest/spirits_and_liquor.svg";
import Icon254 from "./interest/sports.svg";
import Icon255 from "./interest/sports_games.svg";
import Icon256 from "./interest/sports_nutrition.svg";
import Icon257 from "./interest/sportswear_and_lifestyle.svg";
import Icon258 from "./interest/strategy_games.svg";
import Icon259 from "./interest/sustainability.svg";
import Icon260 from "./interest/sweet_treats.svg";
import Icon261 from "./interest/talent_shows.svg";
import Icon262 from "./interest/talk_shows.svg";
import Icon263 from "./interest/tea.svg";
import Icon264 from "./interest/teaching.svg";
import Icon265 from "./interest/technology.svg";
import Icon266 from "./interest/teen_drama.svg";
import Icon267 from "./interest/tennis.svg";
import Icon268 from "./interest/the_great_outdoors.svg";
import Icon269 from "./interest/theatre_and_stage_shows.svg";
import Icon270 from "./interest/theme_parks.svg";
import Icon271 from "./interest/thriller.svg";
import Icon272 from "./interest/toys_and_board_games.svg";
import Icon273 from "./interest/trading.svg";
import Icon274 from "./interest/traffic_and_travel_news.svg";
import Icon275 from "./interest/travel_and_leisure.svg";
import Icon276 from "./interest/trucks.svg";
import Icon277 from "./interest/tv_entertainment.svg";
import Icon278 from "./interest/uk_politics.svg";
import Icon279 from "./interest/uk_travel.svg";
import Icon280 from "./interest/us_politics.svg";
import Icon281 from "./interest/vegan.svg";
import Icon282 from "./interest/vegetarian.svg";
import Icon283 from "./interest/war_drama.svg";
import Icon284 from "./interest/watches.svg";
import Icon285 from "./interest/watching_movies.svg";
import Icon286 from "./interest/water_sports.svg";
import Icon287 from "./interest/weather_news.svg";
import Icon288 from "./interest/weddings_and_getting_married.svg";
import Icon289 from "./interest/weightloss.svg";
import Icon290 from "./interest/wine.svg";
import Icon291 from "./interest/winter_sports.svg";
import Icon292 from "./interest/world_music.svg";
import Icon293 from "./interest/wrestling.svg";
import Icon294 from "./interest/writing.svg";
import Icon295 from "./interest/zero_hunger.svg";
import Icon296 from "./spend/airlines.svg";
import Icon297 from "./spend/alcohol.svg";
import Icon298 from "./spend/automotive_dealership.svg";
import Icon299 from "./spend/bars_and_pubs.svg";
import Icon300 from "./spend/bike_and_scooter_rental.svg";
import Icon301 from "./spend/buses_coaches.svg";
import Icon302 from "./spend/buy_now_pay_later.svg";
import Icon303 from "./spend/car_rental.svg";
import Icon304 from "./spend/cash_and_remittances.svg";
import Icon305 from "./spend/charity.svg";
import Icon306 from "./spend/childrens_clothing.svg";
import Icon307 from "./spend/childrens_toys.svg";
import Icon308 from "./spend/coffee_and_bakery.svg";
import Icon309 from "./spend/convenience_store.svg";
import Icon310 from "./spend/credit_card.svg";
import Icon311 from "./spend/cruises.svg";
import Icon312 from "./spend/education.svg";
import Icon313 from "./spend/electric_vehicles.svg";
import Icon314 from "./spend/electricals_and_technology.svg";
import Icon315 from "./spend/energy.svg";
import Icon316 from "./spend/entertainment_and_leisure.svg";
import Icon317 from "./spend/experiences.svg";
import Icon318 from "./spend/fast_food.svg";
import Icon319 from "./spend/fast_grocery.svg";
import Icon320 from "./spend/ferries.svg";
import Icon321 from "./spend/finance_and_insurance.svg";
import Icon322 from "./spend/fitness.svg";
import Icon323 from "./spend/florist.svg";
import Icon324 from "./spend/footwear.svg";
import Icon325 from "./spend/fuel.svg";
import Icon326 from "./spend/furniture_and_homewares.svg";
import Icon327 from "./spend/gambling_and_betting.svg";
import Icon328 from "./spend/general.svg";
import Icon329 from "./spend/general_fashion.svg";
import Icon330 from "./spend/general_insurance.svg";
import Icon331 from "./spend/groceries.svg";
import Icon332 from "./spend/health_and_beauty_budget.svg";
import Icon333 from "./spend/health_and_beauty_high_end.svg";
import Icon334 from "./spend/health_and_beauty_mid_tier.svg";
import Icon335 from "./spend/hobbies_and_pursuits.svg";
import Icon336 from "./spend/holiday_parking.svg";
import Icon337 from "./spend/home_improvement.svg";
import Icon338 from "./spend/hotels.svg";
import Icon339 from "./spend/household_bills.svg";
import Icon340 from "./spend/jewellery_and_accessories.svg";
import Icon341 from "./spend/life_insurance.svg";
import Icon342 from "./spend/local_council.svg";
import Icon343 from "./spend/marketplace.svg";
import Icon344 from "./spend/meal_boxes.svg";
import Icon345 from "./spend/media_subscriptions.svg";
import Icon346 from "./spend/menswear.svg";
import Icon347 from "./spend/mobile_broadband_and_tv.svg";
import Icon348 from "./spend/mortgage_and_rent.svg";
import Icon349 from "./spend/niche_grocery.svg";
import Icon350 from "./spend/opticians.svg";
import Icon351 from "./spend/out_of_home.svg";
import Icon352 from "./spend/parking.svg";
import Icon353 from "./spend/paypal.svg";
import Icon354 from "./spend/personal_loan.svg";
import Icon355 from "./spend/pet_insurance.svg";
import Icon356 from "./spend/pets.svg";
import Icon357 from "./spend/railways.svg";
import Icon358 from "./spend/restaurant_budget.svg";
import Icon359 from "./spend/restaurant_high_end.svg";
import Icon360 from "./spend/restaurant_mid_tier.svg";
import Icon361 from "./spend/retail.svg";
import Icon362 from "./spend/savings.svg";
import Icon363 from "./spend/sports_and_leisure.svg";
import Icon364 from "./spend/stationery_and_books.svg";
import Icon365 from "./spend/supermarket.svg";
import Icon366 from "./spend/takeaway_delivery.svg";
import Icon367 from "./spend/tax.svg";
import Icon368 from "./spend/taxi.svg";
import Icon369 from "./spend/tolls_and_services.svg";
import Icon370 from "./spend/travel_agent.svg";
import Icon371 from "./spend/travel_holiday.svg";
import Icon372 from "./spend/universal_finance_provider.svg";
import Icon373 from "./spend/universal_retailer.svg";
import Icon374 from "./spend/vehicle_maintenance.svg";
import Icon375 from "./spend/vehicle_transport.svg";
import Icon376 from "./spend/water.svg";
import Icon377 from "./spend/womenswear.svg";
import DefaultIcon from "./default.svg"; // default fallback icon

export const iconMap = {
  cause: {
    animal_welfare: Icon0,
    anti_racism: Icon1,
    armed_forces_charities: Icon2,
    autism: Icon3,
    bird_protection: Icon4,
    cancer_charities: Icon5,
    charity_regulation: Icon6,
    childrens_charities: Icon7,
    climate_change: Icon8,
    countryside: Icon9,
    diabetes_charities: Icon10,
    disability: Icon11,
    dog_welfare: Icon12,
    fairtrade: Icon13,
    feminism: Icon14,
    gardens: Icon15,
    homelessness: Icon16,
    human_rights: Icon17,
    legal_rights: Icon18,
    lgbtq_diversity: Icon19,
    lifeboats_and_coastguards: Icon20,
    mental_health: Icon21,
    ms_charities: Icon22,
    national_development: Icon23,
    nature_protection: Icon24,
    ocean_protection: Icon25,
    old_people_supporters: Icon26,
    pet_protection: Icon27,
    planet_protection: Icon28,
    recycling_and_plastic_free: Icon29,
    refugees_and_equality: Icon30,
    renewable_energy: Icon31,
    the_environment: Icon32,
    tv_fundraising: Icon33,
    vegan_lifestyle: Icon34,
    veganism: Icon35,
    world_aid: Icon36,
    world_wildlife: Icon37,
  },
  "": {
    default: Icon38,
  },
  interest: {
    academia: Icon39,
    accountancy: Icon40,
    action: Icon41,
    action_and_adventure_games: Icon42,
    alcohol: Icon43,
    american_football: Icon44,
    animal_charities: Icon45,
    animation_and_cartoons: Icon46,
    anime: Icon47,
    antiques: Icon48,
    architecture: Icon49,
    art: Icon50,
    art_and_design: Icon51,
    asian_pop_music: Icon52,
    athletics: Icon53,
    award_shows: Icon54,
    baking: Icon55,
    baseball: Icon56,
    basketball: Icon57,
    beauty: Icon58,
    beer_and_cider: Icon59,
    bird_and_wildlife_spotting: Icon60,
    blues_music: Icon61,
    boats: Icon62,
    body_building_and_weightlifting: Icon63,
    bollywood: Icon64,
    books_and_literature: Icon65,
    boxing: Icon66,
    business: Icon67,
    business_advice_and_training: Icon68,
    business_leadership: Icon69,
    business_strategy_and_consultancy: Icon70,
    buying_a_home: Icon71,
    cars: Icon72,
    celebrity_gossip: Icon73,
    chess: Icon74,
    childrens_tv_shows: Icon75,
    classical_music: Icon76,
    climate_and_green_issues: Icon77,
    coffee: Icon78,
    combat_and_fighting_games: Icon79,
    comedy: Icon80,
    comic_books: Icon81,
    computing_and_software: Icon82,
    cooking: Icon83,
    cosmetics: Icon84,
    cosplay: Icon85,
    country_music: Icon86,
    coupons_and_saving_money: Icon87,
    crafts: Icon88,
    cricket: Icon89,
    crime_shows: Icon90,
    cruises: Icon91,
    cycling: Icon92,
    dance_music: Icon93,
    dance_or_ballet: Icon94,
    data: Icon95,
    data_protection: Icon96,
    dating_and_relationships: Icon97,
    design: Icon98,
    diy: Icon99,
    documentaries: Icon100,
    drama: Icon101,
    drawing: Icon102,
    eating_out: Icon103,
    economics: Icon104,
    electric_vehicles: Icon105,
    electronic_music: Icon106,
    electronics: Icon107,
    energy_drinks: Icon108,
    entertainment: Icon109,
    entrepreneurship_and_start_ups: Icon110,
    equestrian_sports: Icon111,
    esports: Icon112,
    ethnic_diversity: Icon113,
    extreme_sports: Icon114,
    family_and_parenting: Icon115,
    fantasy: Icon116,
    fashion: Icon117,
    fashion_affordable: Icon118,
    fashion_luxury: Icon119,
    fashion_premium: Icon120,
    fast_food: Icon121,
    fiction_books: Icon122,
    finance: Icon123,
    financial_technology: Icon124,
    finding_a_job: Icon125,
    fine_art: Icon126,
    fishing: Icon127,
    fitness: Icon128,
    food_and_drink: Icon129,
    food_waste: Icon130,
    football: Icon131,
    furniture: Icon132,
    gambling_and_casinos: Icon133,
    game_shows: Icon134,
    gaming: Icon135,
    gardening: Icon136,
    gender_diversity: Icon137,
    gluten_free: Icon138,
    golf: Icon139,
    gospel_music: Icon140,
    gymnastics: Icon141,
    haircare: Icon142,
    handbags: Icon143,
    health_and_fitness: Icon144,
    health_and_wellbeing: Icon145,
    healthy_eating: Icon146,
    hiking_and_trekking: Icon147,
    hip_hop_music: Icon148,
    historical_drama: Icon149,
    history: Icon150,
    hobbies: Icon151,
    holidays: Icon152,
    horror: Icon153,
    house_and_home: Icon154,
    human_and_civil_rights: Icon155,
    human_resources: Icon156,
    hunting_and_shooting: Icon157,
    insurance: Icon158,
    interior_design: Icon159,
    international_politics: Icon160,
    investment: Icon161,
    jazz_music: Icon162,
    jewellery_and_accessories: Icon163,
    law: Icon164,
    learning_and_education: Icon165,
    legal_drama: Icon166,
    lgbtq: Icon167,
    lifestyle: Icon168,
    lifestyle_tips: Icon169,
    live_music_and_festivals: Icon170,
    local_and_regional_news: Icon171,
    local_and_regional_politics: Icon172,
    magic: Icon173,
    male_grooming: Icon174,
    martial_arts: Icon175,
    maths: Icon176,
    medical_and_health_charities: Icon177,
    medical_drama: Icon178,
    mental_health: Icon179,
    metal_music: Icon180,
    military_and_national_security: Icon181,
    moba_games: Icon182,
    motor_sports: Icon183,
    motorbikes: Icon184,
    motoring: Icon185,
    museums: Icon186,
    music: Icon187,
    music_tv_shows: Icon188,
    musical_drama: Icon189,
    nailcare: Icon190,
    national_and_international_news: Icon191,
    national_politics: Icon192,
    nature_conservation: Icon193,
    netball: Icon194,
    news_and_current_affairs: Icon195,
    news_shows: Icon196,
    no_poverty: Icon197,
    ocean_conservation: Icon198,
    opera: Icon199,
    organic_food: Icon200,
    painting: Icon201,
    performing_arts: Icon202,
    period_drama: Icon203,
    personal_finance: Icon204,
    pets_and_animals: Icon205,
    philanthropy: Icon206,
    philosophy: Icon207,
    phones_and_communication: Icon208,
    photography: Icon209,
    piercing_and_tattoos: Icon210,
    pilates_yoga_and_meditation: Icon211,
    planet_protection: Icon212,
    plastic_free: Icon213,
    playing_music: Icon214,
    poetry: Icon215,
    politics_and_world_affairs: Icon216,
    popular_music: Icon217,
    pr_marketing_and_advertising: Icon218,
    property_and_construction: Icon219,
    public_healthcare: Icon220,
    racing_games: Icon221,
    racket_sports: Icon222,
    radio_shows: Icon223,
    randb_music: Icon224,
    rap_music: Icon225,
    reality_tv_shows: Icon226,
    recycling: Icon227,
    renewable_energy: Icon228,
    rock_music: Icon229,
    romance_drama: Icon230,
    rpg_games: Icon231,
    rugby_league: Icon232,
    rugby_union: Icon233,
    running_marathons_and_triathlons: Icon234,
    science: Icon235,
    science_fiction: Icon236,
    self_improvement: Icon237,
    shoes: Icon238,
    shooter_games: Icon239,
    shopping: Icon240,
    simulation_and_sandbox_games: Icon241,
    singing: Icon242,
    sitcom: Icon243,
    skincare: Icon244,
    sleep_optimisation: Icon245,
    small_business: Icon246,
    smoking_and_vaping: Icon247,
    soap_opera: Icon248,
    socialising: Icon249,
    soft_drinks: Icon250,
    soul_music: Icon251,
    space_and_astronomy: Icon252,
    spirits_and_liquor: Icon253,
    sports: Icon254,
    sports_games: Icon255,
    sports_nutrition: Icon256,
    sportswear_and_lifestyle: Icon257,
    strategy_games: Icon258,
    sustainability: Icon259,
    sweet_treats: Icon260,
    talent_shows: Icon261,
    talk_shows: Icon262,
    tea: Icon263,
    teaching: Icon264,
    technology: Icon265,
    teen_drama: Icon266,
    tennis: Icon267,
    the_great_outdoors: Icon268,
    theatre_and_stage_shows: Icon269,
    theme_parks: Icon270,
    thriller: Icon271,
    toys_and_board_games: Icon272,
    trading: Icon273,
    traffic_and_travel_news: Icon274,
    travel_and_leisure: Icon275,
    trucks: Icon276,
    tv_entertainment: Icon277,
    uk_politics: Icon278,
    uk_travel: Icon279,
    us_politics: Icon280,
    vegan: Icon281,
    vegetarian: Icon282,
    war_drama: Icon283,
    watches: Icon284,
    watching_movies: Icon285,
    water_sports: Icon286,
    weather_news: Icon287,
    weddings_and_getting_married: Icon288,
    weightloss: Icon289,
    wine: Icon290,
    winter_sports: Icon291,
    world_music: Icon292,
    wrestling: Icon293,
    writing: Icon294,
    zero_hunger: Icon295,
  },
  spend: {
    airlines: Icon296,
    alcohol: Icon297,
    automotive_dealership: Icon298,
    bars_and_pubs: Icon299,
    bike_and_scooter_rental: Icon300,
    buses_coaches: Icon301,
    buy_now_pay_later: Icon302,
    car_rental: Icon303,
    cash_and_remittances: Icon304,
    charity: Icon305,
    childrens_clothing: Icon306,
    childrens_toys: Icon307,
    coffee_and_bakery: Icon308,
    convenience_store: Icon309,
    credit_card: Icon310,
    cruises: Icon311,
    education: Icon312,
    electric_vehicles: Icon313,
    electricals_and_technology: Icon314,
    energy: Icon315,
    entertainment_and_leisure: Icon316,
    experiences: Icon317,
    fast_food: Icon318,
    fast_grocery: Icon319,
    ferries: Icon320,
    finance_and_insurance: Icon321,
    fitness: Icon322,
    florist: Icon323,
    footwear: Icon324,
    fuel: Icon325,
    furniture_and_homewares: Icon326,
    gambling_and_betting: Icon327,
    general: Icon328,
    general_fashion: Icon329,
    general_insurance: Icon330,
    groceries: Icon331,
    health_and_beauty_budget: Icon332,
    health_and_beauty_high_end: Icon333,
    health_and_beauty_mid_tier: Icon334,
    hobbies_and_pursuits: Icon335,
    holiday_parking: Icon336,
    home_improvement: Icon337,
    hotels: Icon338,
    household_bills: Icon339,
    jewellery_and_accessories: Icon340,
    life_insurance: Icon341,
    local_council: Icon342,
    marketplace: Icon343,
    meal_boxes: Icon344,
    media_subscriptions: Icon345,
    menswear: Icon346,
    mobile_broadband_and_tv: Icon347,
    mortgage_and_rent: Icon348,
    niche_grocery: Icon349,
    opticians: Icon350,
    out_of_home: Icon351,
    parking: Icon352,
    paypal: Icon353,
    personal_loan: Icon354,
    pet_insurance: Icon355,
    pets: Icon356,
    railways: Icon357,
    restaurant_budget: Icon358,
    restaurant_high_end: Icon359,
    restaurant_mid_tier: Icon360,
    retail: Icon361,
    savings: Icon362,
    sports_and_leisure: Icon363,
    stationery_and_books: Icon364,
    supermarket: Icon365,
    takeaway_delivery: Icon366,
    tax: Icon367,
    taxi: Icon368,
    tolls_and_services: Icon369,
    travel_agent: Icon370,
    travel_holiday: Icon371,
    universal_finance_provider: Icon372,
    universal_retailer: Icon373,
    vehicle_maintenance: Icon374,
    vehicle_transport: Icon375,
    water: Icon376,
    womenswear: Icon377,
  },
} as const;

export function getIconComponent(
  category: string,
  name: string,
): React.FunctionComponent<React.SVGProps<SVGSVGElement>> {
  const categoryMap = iconMap[category as keyof typeof iconMap];

  if (categoryMap && name in categoryMap) {
    return categoryMap[name as keyof typeof categoryMap];
  }

  // console.warn("⚠️ Icon not found: " + category + "/" + name + ", using default.");
  return DefaultIcon;
}
